__turbopack_context__.v({
  "sharer": "ArticleModuleHeroSocialMediaSharer-module-scss-module__Zwlnwq__sharer",
  "wrapper": "ArticleModuleHeroSocialMediaSharer-module-scss-module__Zwlnwq__wrapper",
});
